import { render, staticRenderFns } from "./PosStepDelivery.vue?vue&type=template&id=22c0791e"
import script from "./PosStepDelivery.vue?vue&type=script&lang=js"
export * from "./PosStepDelivery.vue?vue&type=script&lang=js"
import style0 from "./PosStepDelivery.vue?vue&type=style&index=0&id=22c0791e&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports